import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  identityTypes: [],
  selectedIdentityType: null,
  total: 0,
  page: 1,
  pageSize: 10,
  filterName: '',
  filterIsActive: ['true'],
  sortColumn: 'id',
  sortDirection: 'asc',
  loading: false,
  error: null,
  successMessage: null,
};

const identityTypesSlice = createSlice({
  name: 'identityTypes',
  initialState,
  reducers: {
    // Fetch identity types
    fetchIdentityTypes: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchIdentityTypesSuccess: (state, action) => {
      state.identityTypes = action.payload.data;
      state.total = action.payload.meta.total;
      state.loading = false;
      state.error = null;
    },
    fetchIdentityTypesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch identity type by ID
    fetchIdentityTypeById: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchIdentityTypeByIdSuccess: (state, action) => {
      state.selectedIdentityType = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchIdentityTypeByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add identity type
    addIdentityType: (state) => {
      state.loading = true;
      state.error = null;
    },
    addIdentityTypeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    addIdentityTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update identity type
    updateIdentityType: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateIdentityTypeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.selectedIdentityType = null;
      state.error = null;
    },
    updateIdentityTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete identity type
    deleteIdentityType: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteIdentityTypeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    deleteIdentityTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Bulk delete identity types
    bulkDeleteIdentityTypes: (state) => {
      state.loading = true;
      state.error = null;
    },
    bulkDeleteIdentityTypesSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    bulkDeleteIdentityTypesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // UI state management
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
    },
    setFilterName: (state, action) => {
      state.filterName = action.payload;
      state.page = 1;
    },
    setFilterIsActive: (state, action) => {
      state.filterIsActive = action.payload;
      state.page = 1;
    },
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchIdentityTypes,
  fetchIdentityTypesSuccess,
  fetchIdentityTypesFailure,
  fetchIdentityTypeById,
  fetchIdentityTypeByIdSuccess,
  fetchIdentityTypeByIdFailure,
  addIdentityType,
  addIdentityTypeSuccess,
  addIdentityTypeFailure,
  updateIdentityType,
  updateIdentityTypeSuccess,
  updateIdentityTypeFailure,
  deleteIdentityType,
  deleteIdentityTypeSuccess,
  deleteIdentityTypeFailure,
  bulkDeleteIdentityTypes,
  bulkDeleteIdentityTypesSuccess,
  bulkDeleteIdentityTypesFailure,
  setPage,
  setPageSize,
  setFilterName,
  setFilterIsActive,
  setSortColumn,
  setSortDirection,
  clearError,
  clearSuccessMessage,
} = identityTypesSlice.actions;

// Selectors
export const selectIdentityTypes = (state) => state.identityTypes?.identityTypes || [];
export const selectSelectedIdentityType = (state) => state.identityTypes?.selectedIdentityType;
export const selectIdentityTypesLoading = (state) => state.identityTypes?.loading || false;
export const selectIdentityTypesError = (state) => state.identityTypes?.error;
export const selectIdentityTypesSuccessMessage = (state) => state.identityTypes?.successMessage;
export const selectIdentityTypesTotal = (state) => state.identityTypes?.total || 0;
export const selectIdentityTypesPage = (state) => state.identityTypes?.page || 1;
export const selectIdentityTypesPageSize = (state) => state.identityTypes?.pageSize || 10;
export const selectIdentityTypesSortColumn = (state) => state.identityTypes?.sortColumn || 'id';
export const selectIdentityTypesSortDirection = (state) => state.identityTypes?.sortDirection || 'asc';
export const selectIdentityTypesFilterName = (state) => state.identityTypes?.filterName || '';
export const selectIdentityTypesFilterIsActive = (state) => state.identityTypes?.filterIsActive;

export default identityTypesSlice.reducer;
